import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmarkEmpty.svg",
  "use": "checkmarkEmpty.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"checkmarkEmpty.svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.66 4.652a.5.5 0 0 0-.158.31c-.014.098-.02 3.329-.014 7.18.011 6.61.016 7.008.083 7.109.038.059.119.14.178.178.102.067.494.071 7.251.071 6.757 0 7.149-.004 7.251-.071a.717.717 0 0 0 .178-.178c.067-.101.072-.499.083-7.109.006-3.851 0-7.082-.014-7.18a.5.5 0 0 0-.158-.31l-.132-.132H4.792l-.132.132m13.82 7.368v6.5H5.52v-13h12.96v6.5\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol